import { PrimitiveAtom, useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import { chatSettingsAtom } from '@/store/gigiChat/ChatAtom'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'

import CSI from './CSI'

const Container = ({ isSearch }: { isSearch?: boolean }) => {
    const { t } = useTranslation()
    const [chatSettings] = useAtom<PrimitiveAtom<IConversationSettings | null>>(chatSettingsAtom)

    const isWebSearch = () => {
        return chatSettings?.processingStrategy === 'Writing' && chatSettings.processingStrategyWriting.model === 'bing-grounding'
    }

    const getLabel = () => {
        if (isWebSearch()) {
            return t('global.csi.descriptions.writingWebSearch.textInput.short')
        }

        switch (chatSettings?.processingStrategy) {
            case 'QA':
                return t('global.csi.descriptions.qa.textInput.short')
            case 'Writing':
                return t('global.csi.descriptions.writing.textInput.short')
            case 'DocAnalysis':
                return isSearch
                    ? t('global.csi.descriptions.docAnalysis.textInput.short')
                    : t('global.csi.descriptions.docAnalysis.onDocumentUpload.short')
            case 'Translation':
                return isSearch
                    ? t('global.csi.descriptions.translationMode.textInput.short')
                    : t('global.csi.descriptions.translationMode.onDocumentUpload.short')
            default:
                return ''
        }
    }

    return <CSI label={getLabel()} isSearch={isSearch} isWebSearch={isWebSearch()} />
}

export default Container
